import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../components/main/Login.vue'
import LoginWx from '../components/main/LoginWx.vue'
import LoginAtrust from '../components/main/LoginAtrust'
// import i18n from '../i18n'
import store from '@/store'
import Main from '../components/main/Main'
import i18n from '../i18n'
// import userInfo from '../views/users/userInfo'

/* Router Modules */
// import projectRouter from './modules/project'

import EsharedDet from '../views/edoc/EsharedDet'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      // title: i18n.t('users.login.title')
      link: 'components/main/Login'
    }
  },
  {
    path: '/main',
    name: 'Main',
    component: Main,
    children: [],
    meta: {
      title: i18n.t('users.login.title'),
      link: 'components/main/Main'
    }
  },
  {
    path: '/loginwx',
    name: 'LoginWx',
    component: LoginWx,
    meta: {
      // title: i18n.t('users.login.title')
      link: 'components/main/LoginWx'
    }
  },
  {
    path: '/share',
    name: 'EsharedDet',
    component: EsharedDet,
    meta: {
      // title: i18n.t('users.login.title')
      link: 'views/edoc/EsharedDet'
    }
  },
  {
    path: '/ag',
    name: 'LoginAtrust',
    component: LoginAtrust,
    meta: {
      // title: i18n.t('users.login.title')
      link: 'components/main/LoginAtrust'
    }
  }
]

const router = new VueRouter({
  // model: 'history',
  routes
})

router.$addRoutes = (params) => {
  // 替换现有router的routes
  router.matcher = new VueRouter({
    // mode: 'history',
    // routes
  }).matcher
  if (params.length === 0) {
    params = routes
  }
  router.addRoutes(params) // 添加路由
  window.sessionStorage.setItem('dyanmicRouters', JSON.stringify(params))
}

router.onReady(() => {
  // 刷新页面，判断如果登录过并且有权限列表，那么动态加入权限路由
  if (window.sessionStorage.getItem('dyanmicRouters')) {
    store.dispatch('dynamicRouter/getAsyncRoutes')
  }
})
let load = 0
router.beforeEach((to, from, next) => {
  if (to.path === '/login' || to.path === '/loginwx' || to.path === '/share' || to.path === '/ag') {
    // document.title = to.meta.title
    return next()
  } else if ((load === 0) && (from.name === null)) {
    load++
    if ((to.path.toLowerCase().indexOf('/main/') >= 0) || (to.path.toLowerCase().indexOf('/homepage') >= 0)) {
      return next({ path: '/main' })
    } else {
      return next({ path: to.path })
    }
  }
  // 获取token
  const tokenStr = window.sessionStorage.getItem('token')
  if (!tokenStr) {
    return next('/login')
  }
  // if (to.meta.title) {
  //   document.title = to.meta.title
  // }
  next()
})

export default router
